<p class="label">Terms of service</p>
<div class="content">
  <ul>
    <li>
      ข้าพเจ้าขอสัญญาว่าจะไม่นำตัวตนในโลกแห่งความจริงมายุ่งเกี่ยวกับโลกแห่งนี้อย่างเด็ดขาด
      <ul>
        <li>
          ข้าพเจ้าสาบานว่าจะไม่เปิดเผยชื่อที่อยู่ใบหน้าอาชีพหรืออะไรทั้งสิ้นทั้งปวงซึ่งเป็นชีวิตจริงของข้าพเจ้าหาไม่แล้วข้าพเจ้ายินยอมให้แบนไอดีได้
        </li>
      </ul>
    </li>
    <li>
      ข้าพเจ้าขอสัญญาว่าจะพูดจากันด้วยภาษาดอกไม้โลกสวยทุ่งลาเวนเดอร์เนื่องจากข้าพเจ้าเห็นว่าไม่มีความจำเป็นต้องก่อกวน
      ยียวน หรือโมโหกันในโลกแห่งนี้
    </li>
    <li>
      ข้าพเจ้าสาบานว่าเงินที่นำมาซื้อไอเทมเป็นเงินที่ข้าพเจ้าได้มาโดยชอบธรรมและไม่ทำความเดือดร้อนให้ผู้อื่น
    </li>
  </ul>
</div>
<div class="footer-button">
  <button mat-raised-button appThemedButton (click)="goNextFunc()">
    ยินยอม และ ดำเนินการต่อ
  </button>
</div>
<div class="sign-in-section">Already have an account? <a routerLink="/sign-in">Sign in</a></div>
